import styled from 'styled-components';
import icons from '../../assets/sprite.svg';

import ShipStat from "../shipsStat/ShipStat";

const StyledHeader = styled.div`
    display: flex;
    justify-content: center;
    width: 850px;
    margin: 10px auto 30px;
    padding: 20px 0;
    text-align: center;
    font-size: 16px;
    border-radius: 40px;
    background: linear-gradient(145deg, #cacaca, #f0f0f0);
    box-shadow:  10px 10px 30px #bebebe, -10px -10px 30px #ffffff;
    text-transform: uppercase;
`;

const ToggleWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    border-radius: 15px;
    padding: 8px;
    margin: auto 0;
    box-shadow: 9px 9px 16px rgba(189, 189, 189, 0.6),
        -9px -9px 16px rgba(255, 255, 255, 0.5);
`;

const Toggle = styled.div`
    isolation: isolate;
    position: relative;
    height: 150px;
    width: 75px;
    border-radius: 15px;
    overflow: hidden;
    margin: 0 auto;
    box-shadow: inset 10px 10px 15px -10px #c3c3c3,
        inset -10px -10px 15px -10px #ffffff;
    // box-shadow: 
    //     -4px -2px 4px 0px #ffffff,
    //     4px 2px 6px 0px #d1d9e6,
    //     2px 2px 2px 0px #d1d9e6 inset,
    //     -2px -2px 2px 0px #ffffff inset;
`;
const ToggleIndicator = styled.div`
    height: 200%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    background: transparent;
    border-radius: 15px;
    transform: ${props => props.isPlayerTurn ? 'translate3d(0, -75%, 0)' : 'translate3d(0, 25%, 0)'};
    transition: transform 0.4s cubic-bezier(0.85, 0.05, 0.18, 1.35);
    // box-shadow:
    //     -4px -2px 4px 0px #ffffff,
    //     4px 2px 6px 0px #d1d9e6;
`;

const TurnIndicator = styled.svg`
    width: 55px;
    height: 55px;
    margin: 10px;
    outline: 2px solid ${props => props.iconOwner === 'player' ? 'darkgreen' : '#8B0000'};
    outline-offset: 5px;
    border-radius: 5px;
    fill: ${props => props.iconOwner === 'player' ? 'darkgreen' : '#8B0000'};
`;

const ContentWrapper = styled.div`
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    hr {
        width: 95%;
        margin: 0 auto;
        border: 1px solid darkslategray;
        border-radius: 5px;
    }
`;

const Header = ({turn}) => {

    return (
        <StyledHeader>
            <ToggleWrapper>
                <Toggle>
                    <ToggleIndicator isPlayerTurn={turn}>
                        <TurnIndicator iconOwner="computer">
                            <use href={icons + '#computer'}/>
                        </TurnIndicator>
                        <TurnIndicator iconOwner="player">
                            <use href={icons + '#user'}/>
                        </TurnIndicator>
                    </ToggleIndicator>
                </Toggle>
            </ToggleWrapper>
            <ContentWrapper>
                <ShipStat owner="player" isPlayerTurn={turn}/>
                <hr/>
                <ShipStat owner="computer" isPlayerTurn={turn}/>
            </ContentWrapper>
        </StyledHeader>
    );
}

export default Header;